import React from 'react';
import useMe from '../../../hooks/useMe';
import {Alert, Box, BoxProps, Button, Text} from 'components/ui/chakra';
import AdminController from 'puddleglum/api/admin/AdminController';

interface PageProps extends BoxProps {
	children: React.ReactNode;
}

const Page = ({children, ...rest}: PageProps) => {
	const {me} = useMe();

	const handleImpersonationLogout = async () => {
		await AdminController.impersonationLogOut();
		window.location.reload();
	};

	return (
		<Box
			background='linear-gradient(135deg, rgba(245, 243, 239, 0.98) 0%, rgba(217, 200, 169, 0.55) 45%, rgba(195, 211, 217, 0.48) 100%)'
			isolation='isolate'
			minH='100vh'
			overflow='hidden'
			position='relative'
			{...rest}
		>
			<Box
				bg='radial-gradient(circle at top left, rgba(180, 138, 120, 0.22), transparent 30%), radial-gradient(circle at 80% 20%, rgba(138, 141, 95, 0.18), transparent 24%), radial-gradient(circle at bottom right, rgba(77, 106, 117, 0.18), transparent 28%)'
				inset={0}
				position='absolute'
				zIndex={-2}
			/>
			<Box
				bgImage='radial-gradient(rgba(79, 74, 68, 0.18) 0.6px, transparent 0.6px)'
				bgSize='18px 18px'
				inset={0}
				opacity={0.12}
				position='absolute'
				zIndex={-1}
			/>

			{me?.is_impersonating === true && (
				<Alert borderRadius='full' justifyContent='center' m={4} status='warning'>
					<Text pr={4}>
						You are impersonating user {me.first_name} {me.last_name}.
					</Text>
					<Button onClick={handleImpersonationLogout} size='sm' colorScheme='red'>
						Log out
					</Button>
				</Alert>
			)}

			<Box px={4}>{children}</Box>
		</Box>
	);
};

export default Page;
